import { InputMask } from './inputMask';

export const postalCodeMask: InputMask = (e) => {
	const v = (e.target as HTMLInputElement).value.replace(/\D/g, '');
	let newV = '';
	for (let i = 0; i < v.length; i++) {
		if (i < 5) {
			newV = newV.concat(v.charAt(i));
		}
	}
	(e.target as HTMLInputElement).value = newV;
};
